import type { SubscriptionStatus } from './enums';

/**
 * What the admin routes answer with. These are only reachable by a uid or
 * email listed in ADMIN_UIDS / ADMIN_EMAILS on the server; nothing here is a
 * permission check of its own.
 */

export interface AdminUserModel {
  id: string;
  email: string | null;
  displayName: string | null;
  createdAt: string;
  lastSeenAt: string | null;
  subscription: {
    status: SubscriptionStatus;
    active: boolean;
    plan: string;
    startedAt: string | null;
    expiresAt: string | null;
    trialExpiresAt: string | null;
    grantedManually: boolean;
    notes: string | null;
  };
}

export interface AuditEntryModel {
  id: number;
  userId: string;
  actorId: string;
  eventType: string;
  metadata: unknown;
  createdAt: string;
}

export const ADMIN_ACTIONS = ['grant', 'trial', 'cancel', 'revoke', 'expire', 'renew', 'notes'] as const;
export type AdminAction = (typeof ADMIN_ACTIONS)[number];
